import React from 'react'
import Collapsible from 'react-collapsible'
import { DecoratedPlan } from 'src/redux/selectors/plans'
import Feature from './Feature'

import {
  cardBoxShadow as boxShadow,
  categoryBackground,
  style,
} from './pricingTableStyles'

type MobilePricingTableProps = {
  plan: DecoratedPlan
  isOpen: boolean
}

const MobileFeatureCell: React.FC<MobilePricingTableProps> = props => {
  const { plan, isOpen } = props

  // TODO: remove hardcoded disable when features are updated
  const isDisabled = true

  if (isDisabled) {
    return <></>
  }

  return (
    <Collapsible trigger="" open={isOpen}>
      <>
        {plan.categories &&
          plan.categories.map(category => (
            <React.Fragment key={category.title}>
              <div
                style={{
                  ...style.categoryHeader,
                  boxShadow,
                  background: '#fff',
                  margin: '0 3px',
                }}
              >
                {category.title}
              </div>
              {category.features.map((feature, index) => (
                <Feature
                  key={feature.title}
                  id={index}
                  title={feature.title}
                  description={feature.description}
                  hasFeature={feature.hasFeature}
                  tooltipPosition={'left'}
                  hasBoxShadow={true}
                  value={
                    feature.value !== feature.title
                      ? feature.value ?? undefined
                      : undefined
                  }
                  style={{
                    background: categoryBackground,
                  }}
                />
              ))}
            </React.Fragment>
          ))}
      </>
    </Collapsible>
  )
}

export default MobileFeatureCell
